exports.default = {
  'build_success': '創建已完成',
  'build_failed': '創建失敗',
  'build_version': '版本: ',
  'click_to_detail': '點擊查看詳情',
  'permission_box_title': '任務完成後通知我',
  'permission_box_msg': '任務完成後會通過瀏覽器通知你',
  'permission_box_btn': '啟用通知',
  'permission_not_granted': '您已關閉了瀏覽器通知許可權，請在瀏覽器設定中手動開啟',
  'permission_denied': '您拒絕了瀏覽器通知許可權',
  'bill_permission_box_title': '訂單完成後通知我',
  'bill_permission_box_msg': '訂單完成後會通過瀏覽器通知你'
}
